module.exports = __webpack_public_path__ + "img/img3.cf74dc14.png";